import * as React from 'react';
import lang from '@practicegenius/register-account/src/lang';
import {IMT} from '@practicegenius/pg-util/src/StringUtils';
import {NameMismatchScreenType} from '@practicegenius/register-account/src/screens/NameMismatch';
import {BaseScreen} from '../../../components/screens/BaseScreen';

export const NameMismatch: NameMismatchScreenType = ({
  cardNumber,
  linkedPractice,
  actionButtons,
  title,
  instructions,
}) => (
  <BaseScreen
    helmetTitle={lang.nameMismatch.pageTitle}
    headerTitle={lang.nameMismatch.headerTitle}
    title={title}
    instructions={IMT(instructions, {
      cardNumber,
      practiceName: linkedPractice?.name,
    })}
    actionButtons={[
      actionButtons.primary,
      {...actionButtons.secondary, href: '/home'},
    ]}
    cancelProps={{href: '/'}}
    children={null}
  />
);
